const $win = $(window);

function appendEle(element) {
  if ($win.width() < 768) {
    $(".store-results").before(element);
  } else {
    $(".map-holder").append(element);
  }
}

function repositionMap(element) {
  element.remove();
  appendEle(element);

  $win.resize(function() {
    appendEle(element);
  });
}

module.exports = {
  repositionMap
};



// WEBPACK FOOTER //
// ../assets/js/map/reposition-map.js